export class InterfaceElementAlignments{
    public static readonly Left = "ed4fecf4-3eda-49c5-bf36-59c6ab6f7e5b";
    public static readonly Middle = "7b28b650-0c86-43c8-8358-883ad6516047";
    public static readonly Right = "8e2e5b93-c348-4889-b870-aa6ce59397de";

  }
  